var enPT = {
	"image-not-available": "This image be lost t' the briny depths."
};

export { enPT as default };
